import { NEW_ACCOUNT } from '../../../constants';
import { append, assoc, concat, map, path, pathOr, pick, pipe, reduce, when } from 'ramda';

export const getAccountsOptions = ({ accounts, isCreditCard, t }) => pipe(
    map(({ code: value, title }) => ({ value, label: title || value })),
    when(
        () => !isCreditCard,
        append({ value: NEW_ACCOUNT, label: t(NEW_ACCOUNT) })
    )
)(accounts);

export const getFormConfig = ({
  validationConfig: validation,
  defaultSuggestion = '',
  accountFields = [],
  accounts: [account] = []
}) => {
    const fields = pipe(
        map(path(['name'])),
        concat(['amount', 'storedAccountId'])
    )(accountFields);

    const validationConfig = pick(fields, validation);

    const initialValues = pipe(
        reduce((memo, name) => ({ ...memo, [name]: pathOr('', ['accountData', name], account) }), {}),
        assoc('amount', defaultSuggestion),
        when(
            () => account != null,
            assoc('storedAccountId', account.code)
        )
    )(fields);

    return {
        validationConfig,
        initialValues
    };
};
